import {
  Box,
  SystemIcon,
  SystemIconName,
  Typography,
} from '@wishket/design-system';

import { formatViewCount } from '@/shared/utils';

interface CountWithIconProps {
  icon: SystemIconName;
  count: number;
}

// TODO: 유사한 컴포넌트 및 코드 찾아 리팩토링
export const CountWithIcon = ({ icon, count }: CountWithIconProps) => {
  return (
    <Box className="flex items-center gap-1.5">
      <SystemIcon solid name={icon} className="text-w-gray-600" />
      <Typography variant="body3" className="font-medium text-w-gray-600">
        {formatViewCount(count)}
      </Typography>
    </Box>
  );
};
